import React from "react";
import PropTypes from "prop-types";
import { Button, Typography, Grid } from "@mui/material";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-mui";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import Modal from "../../components/Modal";
import { useGroups } from "../../hooks/apiHooks/groups";

const getNewGroupSchema = t => {
  const maxNameLength = 150;

  return Yup.object().shape({
    name: Yup.string()
      .required(t("validationMessages.nameRequired"))
      .max(
        maxNameLength,
        t("validationMessages.cannotExceedLength", {
          type: "Name",
          maxLength: maxNameLength
        })
      )
  });
};

const AddNewGroupModal = ({ onResult }) => {
  const { t } = useTranslation();

  const { createGroup } = useGroups({ fields: { group: ["name"] } });

  return (
    <Formik
      initialValues={{ name: "" }}
      validationSchema={getNewGroupSchema(t)}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        createGroup(values).then(response => onResult(response));
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Modal
          scrollable
          maxWidth="md"
          fullWidth
          dialogTitle={
            <Typography variant="h4" color="textPrimary">
              {t("groupsFilters.addGroup")}
            </Typography>
          }
          dialogContent={
            <Form>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    variant="filled"
                    fullWidth
                    label={t("groupsFilters.addNameField")}
                    component={TextField}
                    name="name"
                    inputProps={{ "data-qa": "add-new-group-modal-name-input" }}
                  />
                </Grid>
              </Grid>
            </Form>
          }
          dialogActions={
            <>
              <Button
                color="primary"
                disabled={isSubmitting}
                onClick={() => {
                  onResult(null);
                }}
              >
                {t("cancelBtn")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={submitForm}
                disabled={isSubmitting}
              >
                {t("createBtn")}
              </Button>
            </>
          }
          open={true}
          onClose={() => {
            onResult(null);
          }}
          showCloseIcon
        />
      )}
    </Formik>
  );
};

AddNewGroupModal.propTypes = {
  onResult: PropTypes.func.isRequired
};

export default AddNewGroupModal;
